<template>
    <div>
        <loading :active.sync="loading.app" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link :to="{name:'account'}" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Data Outlet</div>
        </div>
        <!-- * App Header -->
        <!-- App Capsule -->
        <div id="appCapsule" v-if="loading.app == false">
            <div class="section inset mt-2">
                <div class="wide-block pt-2 pb-2">
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label">Nama Toko/Outlet</label>
                            <input type="text" class="form-control" v-model="customer.name">
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                    </div>
                    <div class="form-group basic">
                        <button class="btn btn-primary btn-block btn-lg" @click="showDialog('show')">Simpan</button>
                    </div>
                </div>
            </div>
        </div>

        <Dialog ref="dialog" :loading="dialogLoading" :title="'Simpan'" @confirm="submit()">
            <p>Anda yakin akan merubah nama toko/outlet?</p>
        </Dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import $axios from './../../api.js'
export default {
    name: 'account.data-outlet',
    data() {
        return {
            dialogLoading: false
        }
    },
    created() {
        setTimeout(() => this.$store.commit('SET_LOADING', {app:false}) , 500);
    },
    computed: {
        ...mapState(['customer','loading','toast'])
    },
    methods: {
        showDialog(value){
            let element = this.$refs.dialog.$el
            window.$(element).modal(value)
        },
        submit(){
            this.dialogLoading = true
            $axios.post('/update-data-outlet', {name:this.customer.name})
            .then((response) => {
                this.showDialog('hide')
                this.dialogLoading = false
                this.$store.commit('SET_CUSTOMER', response.data.data)
                this.$store.commit('SET_TOAST', {show:true,message:response.data.message,tipe:'default',icon:'success'})
            }).catch((error) => {
                this.$store.commit('SET_TOAST', {show:true,message:error.response.data.message,tipe:'default',icon:'danger'})
                this.showDialog('hide')
                this.dialogLoading = false
            })
        }
    },
    destroyed() {
        this.$store.commit('RESET_LOADING')
        this.$store.commit('RESET_TOAST')
    },
}
</script>